import { render, staticRenderFns } from "./FirmDetails.vue?vue&type=template&id=21018c22"
import script from "./FirmDetails.vue?vue&type=script&lang=js"
export * from "./FirmDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports